<template>
  <div class="detail">
    <el-popover
        placement="left"
        width="200"
        trigger="hover"
        >
        <template>
                <div v-if="detail.idCardFront" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                    <viewer style="text-align:center">
                        <img :src="detail.idCardFront" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>身份证正面</p>
                </div>
                <div v-if="detail.idCardReverse" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px"> 
                    <viewer style="text-align:center">
                        <img :src="detail.idCardReverse" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>身份证反面</p>
                </div>
                <div v-if="detail.drivingLicence" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                    <viewer style="text-align:center">
                        <img :src="detail.drivingLicence" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>行驶证</p>
                </div>
                <div v-if="detail.invoice" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                    <viewer style="text-align:center">
                        <img :src="detail.invoice" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>购车发票</p>
                </div>
                <div v-if="detail.contract" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                    <viewer style="text-align:center">
                        <img :src="detail.contract" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>贷款合同</p>
                </div>
                <div v-if="detail.qualifiedCertificate" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                    <viewer style="text-align:center">
                        <img :src="detail.qualifiedCertificate" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>合格证</p>
                </div>
                <div v-if="detail.mileage" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                    <viewer style="text-align:center">
                        <img :src="detail.mileage" alt="" style="width:60px;height:60px">
                    </viewer>
                    <p>里程数</p>
                </div>
                 <div v-if="detail.driveLicence" class="floatimg" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                     <viewer style="text-align:center">
                         <img :src="detail.driveLicence" alt="" style="width:60px;height:60px">
                     </viewer>
                     <p>驾驶证</p>
                </div>
                <div  class="floatimg" v-for="(item,index) in detail.otherList" :key="index" style="text-align: center;width: 50%;float: left;margin-bottom:3px">
                     <viewer style="text-align:center">
                         <img :src="item" alt="" style="width:60px;height:60px">
                     </viewer>
                     <p v-if="detail.otherList">其他文件</p>
                </div>
        </template>
        <el-button  v-preventReClick slot="reference" style="position: fixed;right: 30px;top: 220px;z-index: 999;" class="farstopen">影印件</el-button>
    </el-popover>
        <div class="info" v-if="shenheflag">
          <p>审核记录</p>
          <div class="info_main" style="margin-top:15px">
                  <el-table
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    :data="tableDatashen"
                    style="width: 100%">
                    <el-table-column
                        prop="title"
                        label="审核人员"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="title2"
                        label="审核结果"
                        width="180">
                        <template slot-scope="scope">
                            {{scope.row.title2 == 0 ?'未作废':scope.row.title2 == 1?'待审核':scope.row.title2 == 2?'已作废':'审核未通过'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="title3"
                        label="审核时间">
                    </el-table-column>
                    <el-table-column 
                        prop="title4"
                        label="退款金额">
                        <template slot-scope="scope" v-if="scope.row.title2 == 2">
                            {{scope.row.title4}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="title5"
                        label="反馈">
                    </el-table-column>
                </el-table>
          </div>
      </div>
      <div class="info">
          <p>作废原因</p>
          <div class="info_main">
              <ul>
                 <li style="width: 100%;">作废原因: <span>{{detail.revokeApplyReason}} </span></li> 
              </ul>
          </div>
      </div>
      <!-- <div class="info" v-if="reject">
          <p>驳回理由</p>
          <div class="info_main">
              <ul>
                 <li style="width: 100%;">驳回理由: <span>{{detail.rejectReason}} </span></li> 
              </ul>
          </div>
      </div> -->
      <div class="info">
          <p>基本信息</p>
          <div class="info_main">
              <ul>
                 <li>订单编号: <span>{{detail.code}}</span></li> 
                 <li>订单状态: <span>已完成</span></li> 
                 <li>提交日期: <span>{{detail.submitDate}}</span></li> 
                 <li>销售日期: <span>{{detail.paymentDate}}</span></li> 
                 <li>订单类型: <span>{{detail.saleType == 1?'销售':'续费'}}</span></li> 
                 <li>产品名称: <span>{{detail.productName}}</span></li> 
              </ul>
          </div>
      </div>
      <div class="info">
          <p>保单信息</p>
          <div class="info_main" style="margin-top:15px">
                  <el-table
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    :data="detail.guaranteeSlip"
                    style="width: 100%">
                    <!-- <el-table-column
                        prop="code"
                        label="保单号"
                        width="180">
                        <template slot-scope="scope">
                            {{scope.row.code?scope.row.code : '暂无'}}
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        prop=""
                        label="保单年限"
                        width="180">
                        <template>
                            {{detail.insuranceAge}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="saleMoney"
                        label="保费">
                    </el-table-column>
                    <el-table-column
                         v-if="flagtemplateId"
                        prop="serviceMoney"
                        label="服务费">
                        <template>
                            {{detail.serviceMoney}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="第一受益人">
                        <template>
                            {{detail.beneficiary}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="生效日期">
                        <template>
                            {{detail.effectiveDate}}
                        </template>
                    </el-table-column>
                </el-table>
          </div>
      </div>
      <div class="info">
          <p>车辆所有人</p>
          <div class="info_main">
              <ul>
                 <li>车辆所有类别: <span>{{detail.carNature == 1?'个人':'企业'}}</span></li> 
                 <li>名称: <span>{{detail.name}}</span></li> 
                 <li>证件类型: <span>{{detail.papers == 1?'身份证':detail.papers == 2?'护照':detail.papers == 3?'统一社会信用代码证':'其他'}}</span></li> 
                 <li>证件号码: <span>{{detail.number}}</span></li> 
                 <li>证件详细地址: <span>{{detail.papersAddress}}</span></li> 
                 <!-- <li>常住详细地址: <span>{{detail.permanentAddress}}</span></li>  -->
                 <li>联系电话: <span>{{detail.phone}}</span></li> 
              </ul>
          </div>
      </div>
      <div class="info">
          <p>车辆信息</p>
          <div class="info_main" style="margin-top:15px">
              <ul>
                  <li>车辆类别: <span>{{detail.carType == 1?'新车':detail.carType == 2?'二手车':'旧车'}}</span></li>
                  <li>车辆型号: <span>{{detail.carModelOne+detail.carModelTwo}}</span></li>
                  <li>车辆类型: <span>{{detail.carGenre == 1?'乘用车':detail.carGenre == 2?'商务车':''}}</span></li>
                  <li>车辆排量: <span>{{detail.displacement}}</span></li>
                  <li>发动机号: <span>{{detail.engineNumber}}</span></li>
                  <li>车架号: <span>{{detail.vin}}</span></li>
                  <!-- <li>车牌号: <span>{{detail.plateNumber}}</span></li> -->
                  <li>购车类型: <span>{{detail.buyCarType == 1?'贷款':'全款'}}</span></li>
                  <li>初始购车日期: <span>{{detail.buyCarDate}}</span></li>
                  <li v-if="detail.insuranceExtensionType == 1">原厂质保: <span>{{detail.guaranteeOne}}{{detail.guaranteeOne == ''?'':'年'}}{{ detail.guaranteeTwo}}{{ detail.guaranteeTwo == ''?'':'万公里'}}</span></li>
                  <li >购车发票价格: <span>{{detail.invoicePrice}}</span></li>
                  <li v-if="detail.buyCarType == 1">贷款金额: <span>{{detail.loanAmount}}</span></li>
                  <li v-if="detail.buyCarType == 1">贷款合同号: <span>{{detail.loansNum}}</span></li>
                  <li v-for="(item,index) in list2" :key="index" >{{item.module == 1?item.formName:''}}: <span>{{item.module == 1?item.formValue:''}}</span></li>
              </ul>
          </div>
      </div>
      <div class="info">
          <p>金融公司</p>
          <div class="info_main">
              <ul>
                 <li v-if="detail.buyCarType == 1">金融公司: <span>{{detail.financialCompany}}</span></li> 
              </ul>
          </div>
      </div>
      <div class="info">
          <p>其他信息</p>
          <div class="info_main">
              <ul>
                 <li v-for="(item,index) in list1" :key="index" >{{item.module == 2?item.formName:null}}: <span>{{item.module == 2?item.formValue:null}}</span></li>
              </ul>
          </div>
      </div>
      <div class="info">
          <p>安装信息</p>
          <div class="info_main" style="margin-top:15px">
                  <el-table
                    :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                    :data="tableDataS"
                    style="width: 100%;margin-top:15px">
                    <el-table-column
                        prop="title"
                        label="设备名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="title2"
                        label="设备编码"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="title3"
                        label="安装方">
                    </el-table-column>
                    <el-table-column
                        prop="title4"
                        label="安装时间">
                    </el-table-column>
                </el-table>
          </div>
      </div>
      <!-- <div class="info">
          <p>影印件</p>
          <div class="info_main" style="margin-top:15px">
                <div v-if="detail.idCardFront" class="floatimg"><img :src="detail.idCardFront" alt=""><p>身份证正面</p></div>
                <div v-if="detail.idCardReverse" class="floatimg"><img :src="detail.idCardReverse" alt=""><p>身份证反面</p></div>
                <div v-if="detail.drivingLicence" class="floatimg"><img :src="detail.drivingLicence" alt=""><p>行驶证</p></div>
                <div v-if="detail.invoice" class="floatimg"><img :src="detail.invoice" alt=""><p>购车发票</p></div>
                <div v-if="detail.contract" class="floatimg"><img :src="detail.contract" alt=""><p>贷款合同</p></div>
                <div v-if="detail.qualifiedCertificate" class="floatimg"><img :src="detail.qualifiedCertificate" alt=""><p>合格证</p></div>
                <div v-if="detail.mileage" class="floatimg"><img :src="detail.mileage" alt=""><p>里程数</p></div>
                <div  class="floatimg" v-for="(item,index) in detail.otherList" :key="index">
                     <img :src="item" alt="">
                     <p v-if="detail.otherList">其他文件</p>
                </div>
                <div class="btn">
                    <el-button  v-preventReClick @click="back()">返回</el-button>
                </div>
          </div>
      </div> -->
      <div class="info">
          <p>影印件</p>
          <div class="info_main" style="margin-top:15px">
                <div v-if="detail.idCardFront" class="floatimg">
                    <viewer style="text-align:center">
                        <img :src="detail.idCardFront" alt="">
                    </viewer>
                    <p>身份证正面</p>
                </div>
                <div v-if="detail.idCardReverse" class="floatimg"> <viewer style="text-align:center"><img :src="detail.idCardReverse" alt=""></viewer><p>身份证反面</p></div>
                <div v-if="detail.drivingLicence" class="floatimg"><viewer style="text-align:center"><img :src="detail.drivingLicence" alt=""></viewer><p>行驶证</p></div>
                <div v-if="detail.invoice" class="floatimg"><viewer style="text-align:center"><img :src="detail.invoice" alt=""></viewer><p>购车发票</p></div>
                <div v-if="detail.contract" class="floatimg"><viewer style="text-align:center"><img :src="detail.contract" alt=""></viewer><p>贷款合同</p></div>
                <div v-if="detail.qualifiedCertificate" class="floatimg"><viewer style="text-align:center"><img :src="detail.qualifiedCertificate" alt=""></viewer><p>合格证</p></div>
                <div v-if="detail.mileage" class="floatimg"><viewer style="text-align:center"><img :src="detail.mileage" alt=""></viewer><p>里程数</p></div>
                <div v-if="detail.driveLicence" class="floatimg"><viewer style="text-align:center"><img :src="detail.driveLicence" alt=""></viewer><p>驾驶证</p></div>
                <div  class="floatimg" v-for="(item,index) in detail.otherList" :key="index">
                     <viewer style="text-align:center"><img :src="item" alt=""></viewer>
                     <p v-if="detail.otherList">其他文件</p>
                </div>
               
          </div>
      </div>
      <div class="info" style="border-bottom:none">
          <p>操作日志</p>
          <el-table
                ref="multipleTable"
                :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                :data="recordlist"
                tooltip-effect="dark"
                style="width: 100%;margin-top:10px"
                >
                <el-table-column
                prop="createBy"
                label="操作人id"
                width="180">
                </el-table-column> 
                <el-table-column
                prop="name"
                label="操作人"
                width="180">
                </el-table-column>
                <el-table-column
                prop="action"
                label="操作"
                width="120">
                </el-table-column>
                <el-table-column
                 prop="createTime"
                label="时间"
                width="220"> 
                </el-table-column>
                <el-table-column
                prop="remark"
                label="备注"
                >
                </el-table-column>
            </el-table>
            <div class="btn">
                    <el-button  v-preventReClick @click="back()">返回</el-button>
                </div>
      </div>
  </div>
</template>

<script>
import {getsafedetail,isCharge,recordlistlog} from '../axios/api'
export default {
    data(){
        return{
            tableData:[],
            tableDatasend:[],
            list:[],
            list1:[],
            list2:[],
            reject:false,
            tableDatashen:[],
            detail:{},
            tableDataS:[],
            shenheflag:false,
            flagtemplateId:false,
            isChargemenu:[],
            recordlist:[]
        }
    },
    created(){
        console.log(this.$route.params)
        if(this.$route.params.fail){
            this.reject = true
        }
        this.isCharges()
        this.getdata()
        this.records()
    },
    methods:{
        async records(){
            var {data:dt} = await recordlistlog({
                objId:this.$route.params.ids,
                type:'1'
            })
            console.log(dt)
            if(dt.code == 200){
                this.recordlist = dt.data.list
            }
        },
        back(){
            this.$router.go(-1)
        },
        async isCharges(){
            var {data:dt} = await isCharge({})
            console.log(dt)
            if(dt.code == 200){
                this.isChargemenu = dt.data.isCharge.split(',')
                console.log(this.isChargemenu)
            }
        },
        async getdata(){
            var {data:dt} = await getsafedetail({
                code:this.$route.params.id,
                revokeAuditUser:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.list = []
                this.list2 = []
                this.list1 = []
                this.detail = dt.data.data
                this.list = dt.data.data.extendFieldList.forEach(item=>{
                    console.log(item)
                    if(item.module == 1){
                        
                        this.list2.push(item)
                    }else{
                        
                        this.list1.push(item)
                    }
                })
                // if(dt.data.data.templateId){
                //     if(dt.data.data.templateId.split(',').indexOf('2') !== -1 || dt.data.data.templateId.split(',').indexOf('6') !== -1 || dt.data.data.templateId.split(',').indexOf('10') !== -1 || dt.data.data.templateId.split(',').indexOf('11') !== -1|| dt.data.data.templateId.split(',').indexOf('12') !== -1 || dt.data.data.templateId.split(',').indexOf('14') !== -1){
                //         this.flagtemplateId = true
                //     }else{
                //         this.flagtemplateId = false
                //     }
                // }
                if(dt.data.data.templateId){
                    let charge = this.isChargemenu
                    let template = dt.data.data.templateId.split(',')
                    console.log(charge,template)
                    let aindex = charge.map(items=>{
                        return template.indexOf(items)
                    })
                    console.log(aindex)
                    let bindex = aindex.map(item=>{
                        console.log(item)
                        if(item !== -1){
                            return item
                        }
                    })
                    console.log(bindex)
                    let cindex = []
                    bindex.forEach(item=>{
                        if(item !== undefined){
                            cindex.push(item)
                        }
                    })
                    console.log(cindex)
                    if(cindex.length > 0){
                        this.flagtemplateId = true
                    }else{
                        this.flagtemplateId = false
                    }
                }
                this.tableDataS = []
                let obj = {}
                obj.title = dt.data.data.deviceName
                obj.title2 = dt.data.data.deviceCoding
                obj.title3 = "店内安装"
                obj.title4 = dt.data.data.installTime
                if(dt.data.data.deviceName){
                    this.tableDataS.push(obj)
                }
                this.tableDatashen = []
                let obj1 = {}
                obj1.title = dt.data.data.revokeUser
                obj1.title2 = dt.data.data.revokeState
                obj1.title3 = dt.data.data.revokeAuditDate
                obj1.title4 = dt.data.data.refundMoney
                obj1.title5 = dt.data.data.revokeFeedback
                this.tableDatashen.push(obj1)
                if(dt.data.data.revokeState == 2 || dt.data.data.revokeState == 3){
                    this.shenheflag = true
                }else{
                    this.shenheflag = false
                }
            }
        }
    }
}

</script>
<style lang="less" scoped>
.detail{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .info{
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 15px;
        box-sizing: border-box;
        p{
            font-size: 18px;
            font-weight: 700;
            height: 40px;
            line-height: 40px;
        }
        .info_main{
            overflow: hidden;
            ul{
                overflow: hidden;
                width: 100%;
                li{
                    width: 50%;
                    float: left;
                    height: 45px;
                    line-height: 45px;
                    font-size: 14px;
                }
            }
            .floatimg{
                float: left;
                text-align: center;
                width: 33.33%;
                height: 200px;
                margin-bottom: 30px;
                img{
                    height: 160px;
                    width: 160px;
                }
            }
        }
        .btn{
            margin-top: 55px;
            float: left;
            width: 100%;
            text-align: center;
            button{
                width: 10%;
                margin-right: 2%;
            }
        }
    }
    .info:last-child{
        border-bottom: none;
    }
    .farstopen{
        position: fixed;
        right: 30px;
        top: 220px;
        z-index: 999;
        height: 80px;
        border-radius: 50%;
        width: 80px;
        background: #fff;
        border: 2px solid #005bac;
        text-align: center;
    }
}
</style>
